import BasePath from "./BasePath";

export default {
    getAvailableFactorsExternal: new BasePath("client/v5/external/authorizations"),
    authorizationsKeysExternal: new BasePath("client/v5/external/authorizations/keys"),
    getAvailableFactorsProtected: new BasePath("client/v5/protected/authorizations"),
    authorizationsKeysProtected: new BasePath("client/v5/protected/authorizations/keys"),
    initPasswordRenewal: new BasePath("client/v5/external/passwords/renewal"),
    setPassword: new BasePath("client/v5/external/passwords"),
    checkCredentials: new BasePath("client/v6/external/accounts/credentials/check"),
    login: new BasePath("client/v6/external/login"),
    contractWithdrawalIdentify: new BasePath("client/v5/external/contracts/withdrawals/identify"),
    contractWithdrawalTerminate: new BasePath("client/v5/protected/contracts/withdrawals/terminate"),
    checkConsent: new BasePath("banking/v1/external/consents/check"),
    authorizeConsent: new BasePath("banking/v1/protected/consents/authorize")
};
